import { useQuery } from '@tanstack/react-query';
import { graphql } from '../gql/gql';
import { graphqlRequest, shouldRetryQuery } from '../utils/graphqlClient';
import { GetTripDetailsQuery } from '../gql/graphql';

// Define the GraphQL query
const tripDetailsQuery = graphql(/* GraphQL */ `
  query GetTripDetails($tripId: Int!) {
    tripDetail(tripId: $tripId) {
      tripId
      routeId
      embarkationDate
      disembarkationDate
      boatId
      organizerId
      routeName
      boatName
      diveCount
    }
  }
`);

// Create the custom hook
const useTripDetails = (tripId: number, shouldFetch: boolean) => {
  const { data, isLoading, error } = useQuery<GetTripDetailsQuery>({
    queryKey: ['tripDetails', tripId],
    queryFn: async () =>
      graphqlRequest<GetTripDetailsQuery>(tripDetailsQuery, { tripId }), // Public endpoint, no auth needed
    enabled: shouldFetch && tripId !== null, // Only fetch when tripId is valid
    staleTime: 3600000, // 1 hour
    retry: shouldRetryQuery,
  });

  return {
    tripDetails: data?.tripDetail,
    isLoading,
    error,
  };
};

export default useTripDetails;
